export default __webpack_public_path__ + "static/media/wee.34d0a0fb.jpg";